import { ApiClientService, EntityApiService, RequestConfig, SearchResponseType } from '@dfl/react-security';
import { IResolutionStatus } from '../interfaces/IResolutionStatus';
import { AUDIENCE_TARGET } from '../constants/audience-target';

class ResolutionStatusService extends EntityApiService<IResolutionStatus> {
  searchAudience = async (params?: any, config?: RequestConfig): Promise<SearchResponseType<string>> => {
    return {
      data: Object.keys(AUDIENCE_TARGET).map((target) => {
        return target;
      }),
      hasMore: true,
      total: 2,
    };
  };

  searchAll = (): Promise<IResolutionStatus[]> => {
    return this.search({
      size: 200,
      sort: {
        order: 'asc',
      },
    }).then((data) => data.data);
  };

  mapFilter = (orderStatus: IResolutionStatus) => {
    return {
      type: 'TERM',
      field: 'status._id',
      objectId: true,
      value: orderStatus._id,
    };
  };

  updateTracking = (categoryId: string, value: boolean): any => {
    if (categoryId) {
      return ApiClientService.patch(this.getPath(`/${categoryId}`), {
        tracking: value,
      });
    }
  };
}

export default new ResolutionStatusService('/ms-sales/api/resolution-status');
